var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentStatus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.4,
    height: 28.424,
    viewBox: "0 0 26.4 28.424",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-2.8 -0.776)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22321",
    "data-name": "Path 22321",
    d: "M24,29H8a5,5,0,0,1-5-5V10A1,1,0,0,1,4,9H24a5,5,0,0,1,5,5V24A5,5,0,0,1,24,29ZM5,11V24a3,3,0,0,0,3,3H24a3,3,0,0,0,3-3V14a3,3,0,0,0-3-3Z",
    stroke: "#fff",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22322",
    "data-name": "Path 22322",
    d: "M26,11a1,1,0,0,1-1-1V7.25a2.33,2.33,0,0,0-.78-1.87,1.94,1.94,0,0,0-1.67-.32L5.78,8.87a1,1,0,0,0-.78,1,1,1,0,0,1-2,0A3,3,0,0,1,5.33,6.92L22.11,3.11a3.9,3.9,0,0,1,3.36.71A4.34,4.34,0,0,1,27,7.25V10A1,1,0,0,1,26,11Z",
    transform: "translate(0 -2)",
    stroke: "#fff",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22323",
    "data-name": "Path 22323",
    d: "M28,23H21a4,4,0,0,1,0-8h7a1,1,0,0,1,1,1v6A1,1,0,0,1,28,23Zm-7-6a2,2,0,0,0,0,4h6V17Z",
    stroke: "#fff",
    strokeWidth: 0.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentStatus);
export default __webpack_public_path__ + "static/media/Payment-Status.7baeba9649bde6e91c8f6ba59f8b89fb.svg";
export { ForwardRef as ReactComponent };